import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { ChatFileUploadResult } from '@app/services/chat-file-upload.service';

export interface ChatMessage {
  sender: 'me' | 'other';
  text?: string;
  imageUrl?: string; // optional image attachment preview URL
  timestamp: number;
  senderName?: string; // Name of the sender
  senderAvatar?: string; // Avatar URL of the sender
  date?: string; // Formatted date (e.g., "Jan 15, 2026")
  time?: string; // Formatted time (e.g., "14:30")
  status?: 'sent' | 'delivered' | 'read'; // Message status (like WhatsApp)
  messageId?: number; // Message ID from database
  avatarError?: boolean; // Flag to track if avatar image failed to load
  stepId?: number; // student_course_step_id this message belongs to
  stepTitle?: string; // Title of the step for display
  stepSort?: number; // Step position/order number within the course
  actiontypeId?: number; // Step action type (1=video, 4=essay, etc.)
  courseTitle?: string; // Title of the course for display
  studentCourseId?: number; // student_course_id for navigation
  isNotification?: boolean; // true if this is a system notification (is_notification=1)
  senderRole?: string;
  attentionState?: string;
  ackRequired?: boolean;
  ackAt?: string | null;
  deliveredAt?: string | null;
  readAt?: string | null;
  attachedFiles?: ChatFileUploadResult[];
}

export interface MessageGroup {
  stepId: number | null;
  stepTitle: string;
  courseTitle: string;
  studentCourseId: number | null; // student_course_id for navigation
  messages: ChatMessage[];
}

@Injectable({ providedIn: 'root' })
export class ChatMockService {
  getMockReply(userMessage: string): Observable<ChatMessage> {
    const cannedReplies = [
      'Thanks for your message! We\'ll get back to you shortly.',
      'Could you share a bit more detail?',
      'Got it. Looking into this now.',
      'Understood. I\'ll follow up with the teacher.',
    ];
    const replyText = cannedReplies[Math.floor(Math.random() * cannedReplies.length)];
    const reply: ChatMessage = {
      sender: 'other',
      text: replyText,
      timestamp: Date.now(),
    };
    return of(reply).pipe(delay(700));
  }
}


